import { render } from "./UeLoansListView.vue?vue&type=template&id=3571355a&scoped=true"
import script from "./UeLoansListView.vue?vue&type=script&lang=js"
export * from "./UeLoansListView.vue?vue&type=script&lang=js"

import "./UeLoansListView.vue?vue&type=style&index=0&id=3571355a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3571355a"]])

export default __exports__